import { useState } from "react";

export const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  return (
    <div className="mt-20 grid lg:grid-cols-12 gap-10 items-center" data-testid="before-after">
      <div className="lg:col-span-5">
        <span className="chip chip-red">Redes e bastidores</span>
        <h3 className="h2 mt-5">Antes e depois.</h3>
        <p className="mt-5 text-[var(--text-2)]">
          Intervenção em bastidor de rede com switches e patch panels. Arraste a barra para comparar.
        </p>
      </div>
      <div className="lg:col-span-7">
        <div className="ba-wrap" style={{ "--pos": `${pos}%` }}>
          <img src="/img/rack-depois.webp" alt="Bastidor de rede depois da intervenção" className="ba-img" data-testid="after-image" loading="lazy" decoding="async" width="900" height="1200" />
          <img src="/img/rack-antes.webp" alt="Bastidor de rede antes da intervenção" className="ba-img ba-before" data-testid="before-image" loading="lazy" decoding="async" width="900" height="1200" />
          <span className="ba-label left-4">Antes</span>
          <span className="ba-label right-4 ba-label-blue">Depois</span>
          <div className="ba-handle" />
          <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(+e.target.value)} className="ba-range" aria-label="Comparar antes e depois" data-testid="before-after-slider" />
        </div>
      </div>
    </div>
  );
};
